import { OntarioObstetricalPatientPartnerInformation } from "./OntarioObstetricalPatientPartnerInformation";

class OntarioObstetricalPatientPersonalInformation {
    public BuzzerNumber: string;
    public LeaveMessage: boolean | null;
    public AlternateContact: string;
    public AgeAtEstimatedDateOfBirth: number | null;
    public Language: string;
    public InterpreterRequired: boolean | null;
    public PatientFileNumber: string;
    public DoesDisabilityRequireAccommodation: boolean | null;
    public PartnerInformation: OntarioObstetricalPatientPartnerInformation;
    public Occupation: string;
    public EducationLevel: string;
    public RelationshipStatus: string;
    public SexualOrientation: string;

    constructor(fields?: Partial<OntarioObstetricalPatientPersonalInformation>) {
        Object.assign(this, fields);
        this.PartnerInformation = new OntarioObstetricalPatientPartnerInformation(fields?.PartnerInformation);
    }
}

export { OntarioObstetricalPatientPersonalInformation };
